/**
 * Different enumerations for the state of the profile sub-nav view.
 *
 * @type {Object}
 */
export const PROFILE_SUB_SECTION_STATES = {
  SUB_SECTION_PROFILE: 'sub_section_profile',
  SUB_SECTION_YOUR_INFO: 'sub_section_your_info',
  SUB_SECTION_ADMIN: 'sub_section_admin',
};

/**
 * Human readable sub-nav view titles
 *
 * @type {Object}
 */
export const PROFILE_SUB_SECTION_TITLES = {
  PROFILE: 'Profile',
  YOUR_INFO: 'Your Info',
  ADMIN: 'Admin',
};

/**
 * Map from the human readable titles => the state enumeration.
 *
 * @type {Object}
 */
export const PROFILE_SUB_SECTION_TITLE_TO_STATE_MAP = {
  [PROFILE_SUB_SECTION_TITLES.PROFILE] : PROFILE_SUB_SECTION_STATES.SUB_SECTION_PROFILE,
  [PROFILE_SUB_SECTION_TITLES.YOUR_INFO] : PROFILE_SUB_SECTION_STATES.SUB_SECTION_YOUR_INFO,
  [PROFILE_SUB_SECTION_TITLES.ADMIN] : PROFILE_SUB_SECTION_STATES.SUB_SECTION_ADMIN,
};

/**
 * @type {number}   The default page size for paging project digests
 */
export const PROJECTDIGEST_PAGE_SIZE = 10;

/**
 * @type {string}   Element ID of the block freelancer element.
 */
export const BLOCK_FREELANCER_ELEMENT_ID = 'SH-c-seller-profile-block-freelancer';

/**
 * @type {number}   Cache timeout in ms of how long we'll cache a profile in the client before pulling fresh data.
 */
export const SELLER_PROFILE__CACHE_TIMEOUT_MS = 600000; //6 minutes in ms.

/**
 * @type {string}   Shared class name for the profile overlay scroll view.
 */
export const PROFILE_OVERLAY_SCROLL_VIEW_CLASS = 'SH-c-profile-overlay__scroll-view';

/**
 * @type {string}   Shared class name for the seller-profile-reviews component
 */
export const SELLER_PROFILE__REVIEWS_BACKGROUND_CLASS = 'SH-c-seller-profile-reviews';

/**
 * @type {string}   Element class of the seller-profile-project-list component
 */
export const SELLER_PROFILE_PROJECT_LIST_CLASS = 'SH-c-seller-profile-project-list';

/**
 * @type {number}   Time in ms for the scroll animation to more projects.
 */
export const SELLER_PROFILE_SCROLL_TO_MORE_PROJECTS_IN_MS = 500;

/**
 * For the project company filter, we'll use this to specify the company name of all projects that do NOT have a company
 * associated with them.
 *
 * @type {string}
 */
export const PROJECT_COMPANY_FILTER_UNKNOWN_COMPANY_NAME = 'Other';

/**
 * This will be the company.get('id') if a projectDigest does NOT have a company associated with it.
 *
 * @type {string}
 */
export const PROJECT_COMPANY_FILTER_UNKNOWN_COMPANY_ID = 'other-id';

/** @type {Array} */
export const PROFILE_USER_INCLUDES_BUYER = [
  'actions',
  'actions.user',
  'company.location',
  'company',
  'user-statistics',
];

/** @type {Array} */
export const PROFILE_USER_INCLUDES_SELLER = [
  'actions',
  'actions.user',
  'last-location',
  'location',
  'profile.languages',
  'profile.equipment',
  'service-user-scores.service',
  'services:sort(most-proof)',
  'tags',
  'user-statistics',
  'worked-with-brands.image',
];

/** @type {Array} */
export const PROFILE_PROJECTDIGEST_INCLUDES = [
  'application.buyer',
  'application.brand.image',
  'classifications:subject|industry',
  'image',
  'review.reviewer',
  'services',
  'company',
  'oembed',
  'projectdigest-verifications:verified_or_latest',
  'video-topics',
  'video-category',
  'user',
];

/** @type {Array} */
export const PROFILE_USER_INCLUDES_SELF = [
  'projectdigests.projectdigest-verifications:verified_or_latest:sort(pinned)',
];
